import { ChangeDetectorRef, Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ControlUser } from '../model/controlUser';
import { DevicePilomat } from '../model/devicePilomat';
import { UserService } from '../service/user.service';
import { DeviceService } from 'src/app/service/device.service';
import { Log } from '../util/log';
import { BehaviorSubject } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { AccessMethods } from '../model/accessMethods';
import { DevicePermissionDialogEditorComponent } from '../device-permission-dialog-editor/device-permission-dialog-editor.component';


import { Overlay } from "@angular/cdk/overlay";
import { UserPermissions } from '../model/userPermissions';
import { UserPermissionsList } from '../model/userPermissionsList';

import { DateHelper } from '../util/dateHelper';
import { UserOwnerRel } from '../model/userOwnerRel';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Group } from '../model/group';
import { GroupPermissionsList } from '../model/groupPermissionsList';
import { GroupPermissions } from '../model/groupPermissions';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-add-group',
  templateUrl: './add-group.component.html',
  styleUrls: ['./add-group.component.css']
})
export class AddGroupComponent implements OnInit {


  @ViewChild('addgrouploader', { static: true }) loader;

  groupPermissions = new Map();
  previousPermissions: UserPermissions;

  addGroupForm = new FormGroup({
    name: new FormControl(''),
    description: new FormControl('')
  });

  groupname: string = "";
  groupDescription: string = "";
  ownerUid: string = "";
  groupId: number;
  groupCreated: boolean = false;
  deviceList: DevicePilomat[];
  nameError: boolean = false;

  mapString: string = $localize`:@@groupadd_map: Mappa`;
  listString: string = $localize`:@@groupadd_list: Lista`;

  expiredPermissionsError: boolean = false;
  devicesWithExpiredPermissions: string[] = [];

  // mi serve per disattivare gli input
  canUserEdit: boolean = false;

  //per dirgli di prendere i device dell'owner
  isUserService: boolean = false;

  constructor(
    public appComponent: AppComponent,
    private deviceService: DeviceService,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private overlay: Overlay
  ) { }

  ngOnInit(): void {
  }



  async ngAfterViewInit() {

    this.canUserEdit = await this.canUserEditCheck();

    this.ownerUid = this.route.snapshot.paramMap.get('ownerUid');
    if (!this.ownerUid) {
      this.userService.getMe().subscribe((owner) => {
        this.ownerUid = owner.uid
      })
    }


    this.cdRef.detectChanges();

    this.getDeviceList();
  }


  async canUserEditCheck() {

    const isAlias = await this.appComponent.isAlias();

    if (isAlias) {
      // se è Alias verifico se può modificare
      return await this.checkAliasPermissions("GroupEdit");
    } else {
      //se non è Alias verifico se è Service
      if (this.appComponent.isService()) {
        this.isUserService = true;

        return false;
      } else {
        // se non è né Alias né Service allora può modificare
        return true
      }
    }
  }

  async checkAliasPermissions(feature: string): Promise<boolean> {
    return this.userService.checkAliasPermissions(feature);
  }

  isService(): boolean {
    return this.appComponent.isService();
    // debug
    // return true;
  }

  creategroup() {
    let selectedDevices: boolean = false;

    this.deviceList.forEach(function (device) {
      if (device.selected == true) {
        selectedDevices = true;
        return null;
      }
    });

    if (!selectedDevices && this.groupCreated) {
      let message = $localize`:@@groupadd_no_device_selected: Nessun dispositivo selezionato`;
      let header = $localize`:@@groupadd_no_device_selected_warning: Attenzione`;
      let confirmMessage = $localize`:@@groupadd_no_device_selected_continue: Prosegui`;
      let cancelMessage = $localize`:@@groupadd_no_device_selected_cancel: Annulla`;

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: "350px",
        data: { message, header, confirmMessage, cancelMessage },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {
        if (response) {
          this.saveGroup();
        }
      });
    } else {
      this.saveGroup();
    }
  }

  saveGroup() {
    if (!this.groupId) {

      // il gruppo non esiste va creato

      this.loader.showLoading();

      let createdGroup = new Group();
      createdGroup.name = this.groupname;
      createdGroup.description = this.groupDescription;
      createdGroup.ownerUid = this.ownerUid
      this.userService.createGroup(createdGroup).subscribe((response) => {
        this.loader.hideLoading();
        this.router.navigate(['add-group/' + response.groupId]);
      }, (err) => {
        Log.debug(err);
      });

    } else {
      // il gruppo esiste e va aggiornato
      this.updateGroup();
    }
  }

  getGroupData() {
    this.groupId = parseInt(this.route.snapshot.paramMap.get('uid'));
    if (this.groupId) {
      if (this.canUserEdit || this.isUserService) {
        this.groupCreated = true;
        this.getOwnerGroup();
        Log.debug('The groupid is: ' + this.groupId);
      } else {
        this.groupCreated = true;
        this.getGroup();
        Log.debug('The groupid is: ' + this.groupId);
      }
    } else{
      // gruppo non creato --> creazione nuovo
      setTimeout(() => {
        this.loader.hideLoading();
      }, 500);
    }
  }

  getGroup() {
    this.userService.getGroup(this.groupId).subscribe(
      (result) => {
        this.groupname = result.name;
        this.groupDescription = result.description;
        this.getGroupPermissions();
      },
      (error) => {
        this.loader.hideLoading();
        this.cdRef.detectChanges();
      }
    );

  }

  getOwnerGroup() {
    this.userService.getOwnerGroup(this.groupId, this.ownerUid).subscribe(
      (result) => {
        this.groupname = result.name;
        this.groupDescription = result.description;
        this.getGroupPermissions();
      },
      (error) => {
        this.loader.hideLoading();
        this.cdRef.detectChanges();
      }
    );

  }

  getDeviceListOld() {

    this.deviceService.getDevices().subscribe(
      (devices) => {
        this.deviceList = devices
        this.cdRef.detectChanges();
        this.loader.hideLoading();
        this.getGroupData();
      },
      (error) => {
        this.loader.hideLoading();
        this.cdRef.detectChanges();
      }
    );
  }



  getDeviceList() {
    this.loader.showLoading();

    if (this.canUserEdit || this.isUserService) {

      this.deviceService.getOwnerDevices(this.ownerUid).subscribe(devices => {
        this.deviceList = devices;
        this.cdRef.detectChanges();
        this.getGroupData();;

      }, error => {

        this.loader.hideLoading();
        this.loader.showError();

        this.cdRef.detectChanges();
      });

    } else {
      this.deviceService.getDevices().subscribe(
        (devices) => {
          this.deviceList = devices;
          this.cdRef.detectChanges();
          this.getGroupData();
        },
        (error) => {
          this.loader.hideLoading();
          this.loader.showError();
          this.cdRef.detectChanges();
        }
      );
    }
  }

  onDeviceDeselected(device: DevicePilomat) {
    for (let i = 0; i < this.devicesWithExpiredPermissions.length; i++) {
      if (device.serial == this.devicesWithExpiredPermissions[i]) {
        this.devicesWithExpiredPermissions.splice(i, 1);
      }
    }
    if (this.devicesWithExpiredPermissions.length == 0) {
      this.expiredPermissionsError = false;
    }
    this.groupPermissions.delete(device.serial);
    device.updateIcon();
  }

  onDeviceSelected(device: DevicePilomat) {

    let permissionsForDialogEditor: GroupPermissions = new GroupPermissions();

    if (this.groupPermissions.has(device.serial)) {
      permissionsForDialogEditor = this.groupPermissions.get(device.serial);
    } else {
      permissionsForDialogEditor = null;
    }



    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(DevicePermissionDialogEditorComponent, {
      width: "700px",
      data: { permissions: permissionsForDialogEditor, serial: device.serial, previousPermissions: this.previousPermissions, ownerUid: this.ownerUid },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (!result) {

        if (this.groupPermissions.get(device.systemInfo.serial) === undefined) {

          // if result is false and no permission exists than the dialog has been closed without saving and device has no permission saved
          device.selected = false;
          device.updateIcon();
        }

      } else if (result) {

        result.permissions.groupId = this.groupId;
        // if result exists than the dialog has been closed saving new permissions
        device.selected = true;
        device.shortPermissions = result.permissions.getShortDescription();

        this.groupPermissions.set(device.serial, result.permissions);
        this.previousPermissions = result.permissions;

        device.updateIcon();
      }
    });
  }

  createOwner() {
    this.updateGroup();
    this.loader.hideLoading();
  }

  deleteGroup() {
    let message = $localize`:@@groupadd_delete_group_confirm: Conferma eliminazione gruppo`;
    let confirmMessage = $localize`:@@groupadd_delete_group_confirm_yes: Conferma`;
    let cancelMessage = $localize`:@@groupadd_delete_group_confirm_no: Annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.userService.deleteGroup(this.groupId, this.ownerUid).subscribe((response) => {
          Log.debug("group deleted: ");
          Log.debug(response);
          this.router.navigate(['groups']);
        }, (err) => {
          if (err = "group-in-use") {
            let message = $localize`:@@groupadd_group_has_users: Il gruppo ha degli utenti associati`;
            let header = $localize`:@@groupadd_group_not_deleted: Gruppo non cancellato`;

            const scrollStrategy = this.overlay.scrollStrategies.reposition();

            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
              width: "350px",
              data: { message, header },
              scrollStrategy,
            });
          } else {
            Log.debug(err);
            this.loader.showError();
          }
        });
      }
    });
  }

  updateGroup() {
    //GET users and minutes
    //TODO replace 999 and 123 placeholders
    // this.timeEstimateWarning(999, 123);

    //placeholder in attesa di api
    this.sendGroupUpdate();
  }



  getGroupPermissions() {
    const obs = this.userService.getGroupPermissions(this.groupId, this.ownerUid);
    obs.subscribe((getPermissionsData) => {

      for (let i = 0; i < getPermissionsData.length; i++) {

        this.groupPermissions.set(getPermissionsData[i].serial, getPermissionsData[i]);

        for (let j = 0; j < this.deviceList.length; j++) {

          if (this.deviceList[j].serial == getPermissionsData[i].serial) {
            this.deviceList[j].shortPermissions = getPermissionsData[i].getShortDescription();
            this.deviceList[j].selected = true;
            if (getPermissionsData[i].expiredPermissions) {
              this.expiredPermissionsError = true;
              this.devicesWithExpiredPermissions.push(getPermissionsData[i].serial);
            }
            break;
          }
        }
      }
      let selectedDevices = [];
      let unSelectedDevices = [];
      for (let i = 0; i < this.deviceList.length; i++) {
        if (this.deviceList[i].selected) {
          selectedDevices.push(this.deviceList[i]);
        } else {
          unSelectedDevices.push(this.deviceList[i]);
        }
      }
      this.deviceList = [];
      this.deviceList = this.deviceList.concat(selectedDevices, unSelectedDevices);
      this.loader.hideLoading();
    });
  }

  timeEstimateWarning(users: number, minutes: number) {
    let message = $localize`:@@groupadd_time_warning_message:Questa operazione potrebbe richiedere diversi minuti.Proseguire con l'operazione?`;
    let confirmMessage = $localize`:@@groupadd_delete_group_confirm_yes: Conferma`;
    let cancelMessage = $localize`:@@groupadd_delete_group_confirm_no: Annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "600px",
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.sendGroupUpdate();
      }
    });
  }

  sendGroupUpdate() {
    this.loader.showLoading();
    let groupToPut: Group = new Group();
    groupToPut.name = this.groupname;
    groupToPut.groupId = this.groupId;
    groupToPut.ownerUid = this.ownerUid;
    groupToPut.description = this.groupDescription;


    this.userService.updateGroup(groupToPut, this.groupId).subscribe((response) => {

      let permissionsList: GroupPermissionsList = new GroupPermissionsList();

      this.groupPermissions.forEach((value: GroupPermissions, key: string) => {

        // if device is not selcted the permission is not saved
        this.deviceList.forEach(device => {
          if (device.systemInfo.serial == key && device.selected) {
            permissionsList.permissions.push(value);
          }
        });
      });
      this.userService.updateGroupPermissions(this.groupId, this.ownerUid, permissionsList).subscribe((response) => {
        this.loader.hideLoading();
        this.showGroupUpdatedDialog();
      }, (err) => {
        Log.debug(err);
        this.loader.showError();
      });

    }, (err) => {
      Log.debug(err);
      this.loader.showError();
    });
  }

  showGroupUpdatedDialog() {
    let message = $localize`:@@groupadd_group_updated_successfully:Gruppo aggiornato correttamente`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message },
      scrollStrategy,
    });
  }
}



